import React from 'react';
import PropTypes from 'prop-types';
import Popover from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Popover';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { noop } from 'Helpers/PropTypes';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  MemberThreadFilterMenu,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters/components/ThreadFiltersMenu/components/MemberThreadFilterMenu';
import {
  AgentThreadFilterMenu,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters/components/ThreadFiltersMenu/components/AgentThreadFilterMenu';
import useUserContext from 'Context/UserContext';

const useStyles = buildUseStyles('ThreadTypeFiltersMenuPopover', (theme) => ({
  root: {},
  paper: {
    borderRadius: theme.radius.md,
    marginTop: theme.spacing(1),
  },
  selected: {
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const ThreadFiltersMenuPopover = ({
  handleClose,
  handleEnter,
  open,
  anchorEl,
  onChange,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { resource } = useMetaLayoutContext();
  const { isAgent } = useUserContext();

  return (
    <Popover
      open={open}
      classes={{
        paper: classes.paper,
      }}
      anchorEl={anchorEl}
      onClick={(event) => {
        event.stopPropagation();
      }}
      onClose={handleClose}
      onEnter={handleEnter}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      { isAgent
        ? <AgentThreadFilterMenu resource={resource} onChange={onChange} handleClose={handleClose} />
        : <MemberThreadFilterMenu resource={resource} onChange={onChange} handleClose={handleClose} classes={classes} />
      }
    </Popover>
  );
};

ThreadFiltersMenuPopover.defaultProps = {
  onChange: noop,
  anchorEl: null,
};

ThreadFiltersMenuPopover.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleEnter: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  onChange: PropTypes.func,

};

export { ThreadFiltersMenuPopover };
